/** Rule type: bump extended price up to a minimum when below `minPriceAmount`. */
export const RULE_TYPES_PRODUCT_MIN_PRICE_AMOUNT = 'PRODUCT_MIN_PRICE_AMOUNT';
